module.exports = __webpack_public_path__ + "static/media/photography.f7c9e76f.png";